import { Form, Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { useFetchLeadersQualifications } from "../../../entities/api";

export const LeaderCriteriaSelect = ({ defaultValue, name }) => {
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const [value, setValue] = useState(defaultValue);
  const { data: leadersCriteriaList, isLoading: fetchLeadersCriteriaLoading } = useFetchLeadersQualifications({
    limit: 1000,
  });

  const handleChangeValue = (val) => {
    setValue(val);
  };

  return (
    <>
      <Form.Item name={name} style={{ width: "100%" }}>
        <Select
          showSearch
          value={value}
          disabled={fetchLeadersCriteriaLoading}
          defaultValue={defaultValue}
          loading={fetchLeadersCriteriaLoading}
          onChange={handleChangeValue}
          filterOption={(input, option) => (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())}
        >
          <Select.Option value={""}>--</Select.Option>
          {leadersCriteriaList?.map((leader) => (
            <Select.Option label={leader?.name} value={leader?.leaderCriteriaId} key={leader?.leaderCriteriaId}>
              {leader?.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {value && (
        <Link
          target={"_blank"}
          to={`/${customerId}/admin/${sport}/${organizationId}/leaders-qualification/${value}/qualifiers`}
        >
          {formatMessage({
            id: "view.configuration",
            defaultMessage: "View Configuration",
          })}
        </Link>
      )}
    </>
  );
};
